import { resolveThoughtSummaryWithDuration } from '@/services/chatApi'
import { runTypewriter } from '../streaming/runTypewriter.js'

export function streamApiCompletionText(ctx) {
  const { tid, pendingId, fullText, blocksFromApi, assistantMeta, signal, session, setMessagesByThreadId } =
    ctx

  runTypewriter({
    session,
    signal,
    text: fullText,
    onUpdate: (partial) => {
      setMessagesByThreadId((inner) => {
        const list = [...(inner[tid] ?? [])]
        const idx = list.findIndex((m) => m.id === pendingId)
        if (idx === -1) {
          session.dispose()
          return inner
        }
        const next = [...list]
        next[idx] = {
          ...next[idx],
          text: partial,
          createdAt: Date.now(),
        }
        return { ...inner, [tid]: next }
      })
    },
    onDone: () => {
      setMessagesByThreadId((inner) => {
        const list = [...(inner[tid] ?? [])]
        const idx = list.findIndex((m) => m.id === pendingId)
        if (idx === -1) {
          session.dispose()
          return inner
        }
        const prev = list[idx]
        const next = [...list]
        next[idx] = {
          ...next[idx],
          text: blocksFromApi ? '' : fullText,
          createdAt: Date.now(),
          ...assistantMeta,
          thoughtSummary: resolveThoughtSummaryWithDuration(prev, assistantMeta),
          ...(blocksFromApi ? { blocks: blocksFromApi } : {}),
        }
        return { ...inner, [tid]: next }
      })
      session.dispose()
    },
  })
}
